import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { InterventionFormProps } from "../../../interfaces/admin/InterventionForm";
import { actionTypes } from "../../../store/actionTypes/actionTypes";
import { COMMON } from "../../../constants/common";
import { ADMIN } from "../../../constants/admin";
import { InterventionReducerState } from "../../../interfaces/store/interventionReducerState";
import {
  postDataFromApi,
  putDataFromApi,
} from "../../../services/api/apiService";
import { RestfulUrls } from "../../../constants/restfulUrls";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { INTERVENTION_MEETING_CATEGORIES } from "../../../constants/meetingConstants";

interface CategoryOption {
  label: string;
  value: string;
}

const InterventionForm: React.FC<InterventionFormProps> = ({
  handleDialogClose,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formLoading, setFormLoading] = useState(false);

  const categoryList: CategoryOption[] = Object.entries(INTERVENTION_MEETING_CATEGORIES).map(
    ([value, label]) => ({
      label,
      value,
    })
  );

  const [formData, setFormData] = useState({
    label: "",
    category: "",
    id: "",
  });

  const meetingFormType = useSelector(
    (state: { intervention: InterventionReducerState }) =>
      state.intervention.interventionFormType
  );
  const editFormData = useSelector(
    (state: { intervention: InterventionReducerState }) =>
      state.intervention.interventionSelectedRowData
  );

  const handleChange = (field: string, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (meetingFormType === ADMIN.MEETING_FORM_TYPE.EDIT) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  const handleUpdate = async () => {
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.EDIT_INTERVENTION_LABEL}`;
    const payloadData = { ...formData };
    setFormLoading(true);
    await putDataFromApi<any>(
      url,
      payloadData,
      () => {
        dispatch({
          type: COMMON.SHOW_SNACKBAR,
          payload: {
            message: "Intervention Label updated successfully.",
            severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
          },
        });
        dispatch({
          type: actionTypes.UPDATE_FETCH_INTERVENTION_LABEL,
          payload: true,
        });
        handleDialogClose();
        setFormLoading(false);
      },
      { isAuthRequired: true },
      navigate
    );
    setFormLoading(false);
  };

  const handleCreate = async () => {
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.ADD_INTERVENTION_LABEL}`;
    const payloadData = { ...formData };
    setFormLoading(true);
    await postDataFromApi<any>(
      url,
      payloadData,
      () => {
        dispatch({
          type: COMMON.SHOW_SNACKBAR,
          payload: {
            message: "Intervention Label created successfully.",
            severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
          },
        });
        dispatch({
          type: actionTypes.UPDATE_FETCH_INTERVENTION_LABEL,
          payload: true,
        });
        handleDialogClose();
        setFormLoading(false);
      },
      { isAuthRequired: true },
      navigate
    );
    setFormLoading(false);
  };

  useEffect(() => {
    if (editFormData) {
      setFormData({
        label: editFormData.label,
        category: editFormData.category,
        id: editFormData.id,
      });
    }
  }, [editFormData]);
  return (
    <>
      <form id='login-form' onSubmit={handleSubmit}>
        <Grid container rowSpacing={2} sx={{ mb: 2, width: "500px" }}>
          <Grid item xs={12}>
            <TextField
              required
              label='Label'
              variant='outlined'
              fullWidth
              value={formData.label}
              onChange={(e) => handleChange("label", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel id='tag-select-label'>Category</InputLabel>
              <Select
                labelId='tag-select-label'
                value={formData.category}
                label='Category'
                onChange={(e) => handleChange("category", e.target.value)}
              >
                {categoryList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant='outlined' onClick={handleDialogClose} sx={{ mr: 1 }}>
            Cancel
          </Button>
          {meetingFormType === ADMIN.MEETING_FORM_TYPE.EDIT ? (
            <Button variant='contained' type='submit' disabled={formLoading}>
              Update
            </Button>
          ) : (
            <Button variant='contained' type='submit' disabled={formLoading}>
              Create
            </Button>
          )}
        </Box>
      </form>
    </>
  );
};

export default InterventionForm;
